export const APIRoute = {
  POST_RESET_PASSWORD: '/api/1/reset-password',
  POST_ACTIVATE_ACCOUNT: '/api/1/activate-account',
  POST_VALIDATE_TOKEN: '/api/1/validate-token',

  GET_COUNTRIES: '/api/1/countries',
  GET_COUNTRIES_WITH_CLUBS: '/api/1/countries-with-clubs',
  GET_COUNTRY_STATES: (countryId: number) => `/api/1/countries/${countryId}/states`,
  POST_SEARCH_CLUBS: '/api/1/clubs/search',
  GET_CLUB: (clubId: number) => `/api/1/clubs/${clubId}`,
  PUT_CLUB: (clubId: number) => `/api/1/clubs/${clubId}`,
  PUT_CLUB_DEACTIVATE: (clubId: number) => `/api/1/clubs/${clubId}/deactivate`,
  PUT_CLUB_REACTIVATE: (clubId: number) => `/api/1/clubs/${clubId}/reactivate`,
  GET_CLUB_COURSES: (clubId: number) => `/api/1/clubs/${clubId}/courses`,
  POST_CLUB_GENERATE_INITIAL_MAPPING: (clubId: number) => `/api/1/clubs/${clubId}/generate-initial-mapping`,
  POST_CLUB: '/api/1/clubs',
  POST_TRANSFER_CLUB_PROVIDER_MAPPING: '/api/1/clubs/transfer-provider-mapping',
  GET_CONFIGURATION: '/api/1/configuration',

  POST_SEARCH_COURSES: '/api/1/courses/search',
  GET_COURSE: (courseId: number) => `/api/1/courses/${courseId}`,
  GET_COURSES_BY_IDS: `/api/1/courses`,
  GET_COURSES_BY_COURSE_OR_CLUB_NAME: `/api/1/courses/search-by-name`,
  POST_ADD_COURSE: '/api/1/courses',
  PUT_COURSE: (courseId: number) => `/api/1/courses/${courseId}`,
  POST_COURSE_VERSION: (courseId: number) => `/api/1/courses/${courseId}/version`,
  PUT_COURSE_DEACTIVATE: (courseId: number) => `/api/1/courses/${courseId}/deactivate`,
  PUT_COURSE_REACTIVATE: (courseId: number) => `/api/1/courses/${courseId}/reactivate`,
  PUT_COURSE_VERSION: (courseVersionId: number) => `/api/1/course-versions/${courseVersionId}`,
  POST_COURSE_VERSION_ZENDESK: (courseId: number, version: number) =>
    `/api/1/courses/${courseId}/versions/${version}/zendesk-ticket`,
  PUT_COURSE_VERSION_OFFICIAL: (courseVersionId: number) => `/api/1/course-versions/${courseVersionId}/official`,
  PUT_COURSE_VERSION_UNOFFICIAL: (courseVersionId: number) => `/api/1/course-versions/${courseVersionId}/unofficial`,
  PUT_COURSE_VERSION_REVIEWED: (courseVersionId: number) => `/api/1/course-versions/${courseVersionId}/reviewed`,
  POST_DUPLICATE_COURSE: (courseId: number) => `/api/1/courses/${courseId}/duplicate`,
  POST_TRANSFER_COURSE: (courseId: number) => `/api/1/courses/${courseId}/transfer`,
  POST_COURSE_GENERATE_INITIAL_MAPPING: (courseId: number) => `/api/1/courses/${courseId}/generate-initial-mapping`,
  POST_COURSE_VERSION_GENERATE_INITIAL_MAPPING: (courseVersionId: number) =>
    `/api/1/course-versions/${courseVersionId}/generate-initial-mapping`,
  POST_COURSE_RESET_MAPPING: (courseId: number) => `/api/1/courses/${courseId}/reset-mapping`,
  PUT_COURSE_GPS_VERSION_OFFICIAL: (courseId: number) => `/api/1/courses/${courseId}/gps/official`,
  PUT_COURSE_GPS_VERSION_UNOFFICIAL: (courseId: number) => `/api/1/courses/${courseId}/gps/unofficial`,
  PUT_COURSE_GPS_VERSION_REVIEWED: (courseId: number, gpsVersion: number) =>
    `/api/1/courses/${courseId}/gps/versions/${gpsVersion}/reviewed`,
  POST_COURSE_GPS_VERSION: (courseId: number) => `/api/1/courses/${courseId}/gps/version`,
  POST_COURSE_GPS_VERSION_ZENDESK: (courseId: number, version: number) =>
    `/api/1/courses/${courseId}/gps/versions/${version}/zendesk-ticket`,
  PUT_COURSE_GPS_VERSION_FLIP_MAPPING: (courseId: number) => `/api/1/courses/${courseId}/gps/flip-mapping`,
  PUT_COURSE_GPS_COPY_MAPPING: (courseId: number) => `/api/1/courses/${courseId}/gps/copy-mapping`,
  POST_COURSE_HOLE_STATS_INIT: (courseId: number) => `/api/1/courses/${courseId}/hole-stats`,
  GET_COURSE_HOLE_STATS_STATUS: (courseId: number, taskId: string) => `/api/1/courses/${courseId}/hole-stats/${taskId}`,
  DELETE_COURSE_HOLE_STATS: (courseId: number, taskId: string) => `/api/1/courses/${courseId}/hole-stats/${taskId}`,
  POST_COURSE_HOLE_STATS_RESULTS: (courseId: number, taskId: string) =>
    `/api/1/courses/${courseId}/hole-stats/${taskId}`,

  POST_COURSE_TEEBOX_MAPPING: (courseId: number) => `/api/1/courses/${courseId}/teebox-mapping`,
  POST_TRANSFER_COURSE_PROVIDER_MAPPING: '/api/1/courses/transfer-provider-mapping',
  POST_UPDATE_COURSE_PROVIDER_VERSION: (providerId: number) => `/api/1/providers/${providerId}/course-versions`,
  PUT_UPDATE_COURSE_PROVIDER_VERSION_MAP: (courseId: number, courseVersionId: number, providerVersionId: number) =>
    `/api/1/courses/${courseId}/versions/${courseVersionId}/provider-version-maps/${providerVersionId}`,
  GET_PROVIDER_CLUBS_AND_COURSES_SEARCH: (providerId: string) => `/api/1/providers/${providerId}/clubs`,
  PUT_ADD_COURSE_PROVIDER_MAPPING: (courseId: number, courseProviderMapId: number) =>
    `/api/1/courses/${courseId}/provider-maps/${courseProviderMapId}`,
  PUT_ADD_CLUB_PROVIDER_MAPPING: (clubId: number, clubProviderMapId: string) =>
    `/api/1/clubs/${clubId}/provider-maps/${clubProviderMapId}`,

  GET_CHALLENGE: (challengeId: string) => `/api/1/challenges/${challengeId}`,
  GET_CHALLENGE_LEADERBOARD: (challengeId: string) => `/api/1/challenges/${challengeId}/leaderboard`,
  GET_CHALLENGE_LEADERBOARD_REPORT: (challengeId: string) => `/api/1/challenges/${challengeId}/leaderboard/report`,
  GET_CURRENT_CHALLENGES: '/api/1/challenges/current',
  GET_PAST_CHALLENGES: '/api/1/challenges/past',
  GET_CHALLENGE_TYPES: '/api/1/challenge-types',
  GET_CHALLENGE_OPTS: '/api/1/challenge-opts',
  POST_CREATE_CHALLENGE: '/api/1/challenges',
  PUT_UPDATE_CHALLENGE: (challengeId: string) => `/api/1/challenges/${challengeId}`,
  POST_DUPLICATE_CHALLENGE: (challengeId: string) => `/api/1/challenges/${challengeId}/duplicate`,
  DELETE_CHALLENGE: (challengeId: string) => `/api/1/challenges/${challengeId}`,
  POST_CHALLENGE_IMAGE: '/api/1/challenges/upload-image',
  DELETE_CHALLENGE_PLAYER: (challengeId: string, playerId: string) =>
    `/api/1/challenges/${challengeId}/players/${playerId}`,
  POST_ADD_CHALLENGE_PLAYER: (challengeId: string, playerId: number) =>
    `/api/1/challenges/${challengeId}/players/${playerId}`,

  GET_USERS: '/api/1/users',
  GET_PRIVILEGE_USERS: '/api/1/users/privileges',
  GET_USER: (userId: string) => `/api/1/users/${userId}`,
  GET_USER_ROUNDS: (userId: number) => `/api/1/users/${userId}/rounds`,
  GET_USER_CHALLENGES_V1: (userId: number) => `/api/1/users/${userId}/challenges`,
  PUT_UPDATE_USER: (userId: number) => `/api/1/users/${userId}`,
  DELETE_USER: (userId: number) => `/api/1/users/${userId}`,
  DELETE_USER_IMAGE: (userId: number, imageType: 'avatar' | 'cover') => `/api/1/users/${userId}/images/${imageType}`,
  GET_USER_PRIVILEGES: (userId: number) => `/api/1/users/${userId}/privileges`,
  POST_USER_PRIVILEGE: (userId: number) => `/api/1/users/${userId}/privileges`,
  PUT_USER_PRIVILEGE: (privilegeId: number) => `/api/1/users/privileges/${privilegeId}`,
  DELETE_USER_PRIVILEGE: (privilegeId: number) => `/api/1/users/privileges/${privilegeId}`,
  GET_USER_STATS: (userId: number) => `/api/1/users/${userId}/stats`,
  GET_USER_EXTRA: (userId: number) => `/api/1/users/${userId}/extra`,
  GET_USER_GAME_STATS: (userId: number) => `/api/1/users/${userId}/game-stats`,
  GET_USER_LINKED_ACCOUNTS: (userId: number) => `/api/1/users/${userId}/linked-accounts`,

  GET_GAME: (gameId: number) => `/api/1/games/${gameId}`,
  GET_GAME_LEADERBOARD: (gameId: number) => `/api/1/games/${gameId}/leaderboard`,
  GET_GAME_CONTESTS: (gameId: number) => `/api/1/games/${gameId}/contests`,
  GET_GAME_LOGS: (gameId: number) => `/api/1/games/${gameId}/logs`,
  PUT_UPDATE_GAME: (gameId: number) => `/api/1/games/${gameId}`,
  DELETE_GAME: (gameId: number) => `/api/1/games/${gameId}`,
  DELETE_GAME_ROUND: (gameId: number, roundId: number) => `/api/1/games/${gameId}/rounds/${roundId}`,
  DELETE_GAME_PLAYER: (gameId: number, playerId: number) => `/api/1/games/${gameId}/players/${playerId}`,
  GET_GAMES: '/api/1/games',

  GET_GAME_FORMATS: '/api/1/game-formats',
  GET_PRIVILEGES: '/api/1/privileges',
  GET_TIMEZONES: '/api/1/timezones',
  GET_PROVIDERS: '/api/1/providers',

  GET_ADMIN_USERS: '/api/1/users/admin',
  PUT_UPDATE_ADMIN_USER: (userId: number) => `/api/1/users/admin/${userId}`,
  DELETE_ADMIN_FROM_USER: (userId: number) => `/api/1/users/admin/${userId}`,
  POST_RESET_MFA_FOR_ADMIN_USER: (userId: number) => `/api/1/users/admin/reset-mfa/${userId}`,

  // API V2 routes
  GET_CHALLENGE_LEADERBOARD_REPORT_V2: (challengeId: string) => `/api/2/challenges/${challengeId}/leaderboard/report`,
  CHALLENGE_UPLOAD_IMAGE_TO_S3: (uploadUrl: string) => uploadUrl,

  //Cognito admin user
  POST_CREATE_COGNITO_USER: `/api/1/cognito-users`,
  GET_COGNITO_USERS: `/api/1/cognito-users`,
  DELETE_COGNITO_USER: `/api/1/cognito-users`,
  POST_RESEND_COGNITO_INVITATION: (email: string) => `/api/1/cognito-users/${encodeURIComponent(email)}/invitations`,
  PUT_EDIT_COGNITO_USER: '/api/1/cognito-users',
}
